'use client'

import { ComponentProps } from 'react'
import { useSearchParams } from 'next/navigation'

import { SpaceCard } from '~/domains/search/components/space-card'
import { getSpaceDetailsSearch } from '~/domains/spaces/lib/get-space-details-search'

export const DistrictPageSpaceCard = ({
	href,
	...props
}: ComponentProps<typeof SpaceCard>) => {
	const searchParams = useSearchParams()
	const bookingSearch = getSpaceDetailsSearch(searchParams)

	return (
		<SpaceCard
			href={`${href}${bookingSearch ? `?${bookingSearch}` : ''}`}
			{...props}
		/>
	)
}
